export enum SubmitStatus {
  SUCCESS = "success",
  ERROR = "error",
  INACTIVE = "inactive",
}
